let bundleSelector1 = document.querySelector(".bundle__selector__1");
let bundleSelector2 = document.querySelector(".bundle__selector__2");
let bundleSelector3 = document.querySelector(".bundle__selector__3");
let fieldset = document.querySelector(".shopify_subscriptions_app_block ");
var sellingPlanSelector = document.querySelector(".selected-selling-plan-id");
let quantityInput = document.getElementsByName("quantity")[0];
let cartDrawer = document.getElementsByTagName("cart-drawer")[0];
var activePrice = "price__regular__1";
var activeComparePrice = "none";
var activeUnitPrice = "unit__price__regular__1";
let bundleSelectorTagSub1 = document.querySelector(".bundle__selector__tag__1");
let bundleSelectorTagBundle2 = document.querySelector(
  ".bundle__selector__tag__bundle__2"
);
let bundleSelectorTagSub2 = document.querySelector(
  ".bundle__selector__tag__sub__2"
);
let bundleSelectorTagBundle3 = document.querySelector(
  ".bundle__selector__tag__bundle__3"
);
let bundleSelectorTagSub3 = document.querySelector(
  ".bundle__selector__tag__sub__3"
);
let sub = false;

if (fieldset) {
  sub = true;
}

checkForMultipack();

bundleSelector1.addEventListener("click", function () {
  quantityInput.value = 1;
  updateThemePrice(this.value);
});

bundleSelector2.addEventListener("click", function () {
  quantityInput.value = 2;
  updateThemePrice(this.value);
});

bundleSelector3.addEventListener("click", function () {
  quantityInput.value = 3;
  updateThemePrice(this.value);
});

if (sub) {
  fieldset.addEventListener("change", function () {
    checkPrice(this);
  });
}

document.querySelector(".price__regular").style.display = "none !important";

function updateThemePrice(priceID) {
  if (sub && sellingPlanSelector.value) {
    updateTags("sub");
    switch (priceID) {
      case "1":
        showPrice("price__sub__discount__1");
        showComparePrice("price__regular__1");
        showUnitPrice("unit__sub__discount__1");
        break;
      case "2":
        showPrice("price__sub__discount__2");
        showComparePrice("price__regular__2");
        showUnitPrice("unit__sub__discount__2");
        break;
      case "3":
        showPrice("price__sub__discount__3");
        showComparePrice("price__regular__3");
        showUnitPrice("unit__sub__discount__3");
        break;
      default:
    }
  } else {
    updateTags("bundle");
    switch (priceID) {
      case "1":
        showComparePrice("none");
        showPrice("price__regular__1");
        showUnitPrice("unit__price__regular__1");
        break;
      case "2":
        showPrice("price__discount__2");
        showComparePrice("price__regular__2");
        showUnitPrice("unit__price_discount_2");
        break;
      case "3":
        showPrice("price__discount__3");
        showComparePrice("price__regular__3");
        showUnitPrice("unit__price_discount_3");
        break;
      default:
    }
  }
}

function hidePrice(priceName) {
  if (priceName === "none") return;
  document
    .querySelector("." + priceName)
    .firstElementChild.classList.add("visually-hidden");
  document
    .querySelector("." + priceName)
    .firstElementChild.classList.remove("bundle__price__sale");
}

function hideComparePrice(priceName) {
  if (priceName === "none") return;
  document
    .querySelector("." + priceName)
    .firstElementChild.classList.add("visually-hidden");
  document
    .querySelector("." + activeComparePrice)
    .firstElementChild.classList.remove("bundle__price__compare");
}

function hideUnitPrice(priceName) {
  if(!document.querySelector("." + activeUnitPrice))
    return;
  document.querySelector("." + priceName).classList.add("visually-hidden");
}

function showPrice(priceName) {
  if (activePrice === priceName) return;
  hidePrice(activePrice);
  activePrice = priceName;
  if (priceName != "price__regular__1")
    document
      .querySelector("." + priceName)
      .firstElementChild.classList.add("bundle__price__sale");
  document
    .querySelector("." + activePrice)
    .firstElementChild.classList.remove("visually-hidden");
}

function showComparePrice(priceName) {
  if (activeComparePrice === priceName) return;
  hideComparePrice(activeComparePrice);
  activeComparePrice = priceName;
  if (priceName === "none") return;
  document
    .querySelector("." + activeComparePrice)
    .firstElementChild.classList.add("bundle__price__compare");
  document
    .querySelector("." + activeComparePrice)
    .firstElementChild.classList.remove("visually-hidden");
}

function showUnitPrice(priceName) {
  if(!document.querySelector("." + activeUnitPrice))
    return;
  if (activeUnitPrice === priceName) return;
  hideUnitPrice(activeUnitPrice);
  activeUnitPrice = priceName;
  document
    .querySelector("." + activeUnitPrice)
    .classList.remove("visually-hidden");
}

function checkPrice() {
  updateThemePrice(
    document.querySelector('input[name="bundle"]:checked').value
  );
}

function updateTags(activeTags) {
  switch (activeTags) {
    case "bundle":
      bundleSelectorTagSub1.classList.add("visually-hidden");
      bundleSelectorTagSub2.classList.add("visually-hidden");
      bundleSelectorTagSub3.classList.add("visually-hidden");
      bundleSelectorTagBundle2.classList.remove("visually-hidden");
      bundleSelectorTagBundle3.classList.remove("visually-hidden");
      break;
    case "sub":
      bundleSelectorTagBundle2.classList.add("visually-hidden");
      bundleSelectorTagBundle3.classList.add("visually-hidden");
      bundleSelectorTagSub1.classList.remove("visually-hidden");
      bundleSelectorTagSub2.classList.remove("visually-hidden");
      bundleSelectorTagSub3.classList.remove("visually-hidden");
      break;
  }
}

function checkForMultipack() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  let multipackValue = params.get('multipack'); 
  if (multipackValue == "2" || multipackValue == "3") {
    switch (multipackValue) {
      case "2":
        bundleSelector2.checked = true;
        quantityInput.value = 2;
        checkPrice();
        break;
      case "3":
        bundleSelector3.checked = true;
        quantityInput.value = 3;
        checkPrice();
        break;
      default:
        break;
    }
  }
}

const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      const classList = mutation.target.classList;
      if (classList.contains('active')) {
      } else {
        quantityInput.value = document.querySelector('input[name="bundle"]:checked').value;
      }
    }
  });
});

observer.observe(cartDrawer, { attributes: true });

